import posthog from 'posthog-js'
import { isDevHost } from '@/utils/devHost'

/**
 * Swedish VAT, a flat 25% on everything we sell.
 *
 * Every revenue figure we report is EX VAT: the `memberships` table, PostHog
 * Revenue Analytics, and the Google Ads conversion value. Prices shown to the
 * customer are inc VAT ("Totalbelopp ink moms"), so anything derived from a
 * displayed price has to divide this out before it is reported as revenue.
 * Reporting some sources gross and others net is how revenue ends up quoted
 * 25% high, so keep the two bases strictly apart.
 */
export const VAT_RATE = 0.25

/**
 * Gross (what the customer pays) -> net (what we report as revenue).
 */
export function exVat (grossPrice) {
  return Math.round((grossPrice / (1 + VAT_RATE)) * 100) / 100
}

/**
 * Record something a user actually accomplished.
 *
 * Sends to two places on purpose:
 *   1. PostHog  - so the event shows up in product analytics, funnels and reports.
 *   2. GTM dataLayer - so a Google Ads conversion tag can be attached to it in
 *      Google Tag Manager (container GTM-PM4GDW6) without another code change.
 *      Conversions with a `value` let Google Ads report ROAS per campaign.
 *
 * Never let analytics break the app: every call is wrapped.
 *
 * Naming: snake_case verbs in the past tense (`membership_purchased`), so the
 * event list stays readable as it grows.
 */
export function track (name, props) {
  var payload = props || {}

  if (isDevHost()) {
    console.log('[track (dev)]', name, payload)
    return
  }

  try {
    posthog.capture(name, payload)
  } catch (e) {
    // analytics must never take the page down
  }

  try {
    window.dataLayer = window.dataLayer || []
    var gtmPayload = { event: name }
    for (var key in payload) {
      if (Object.prototype.hasOwnProperty.call(payload, key)) {
        gtmPayload[key] = payload[key]
      }
    }
    window.dataLayer.push(gtmPayload)
  } catch (e) {
    // dataLayer may be absent if GTM is blocked by an ad blocker
  }
}
